import {
  Stack,
  Typography
} from "@mui/material";
import {
  alpha,
  useTheme
} from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { StyledModal } from "./EditionInProgressWarningModal.styles";
import { ButtonDigited } from "../Button/Button.variants";
import { Icon } from "../Icon";

export function EditionInProgressWarningModal({
  showChangeEditionWarning,
  setShowChangeEditionWarning,
  onChangeEditionClick
}: {
    showChangeEditionWarning: boolean
    setShowChangeEditionWarning: (show: boolean) => void
    onChangeEditionClick?: () => void
}) {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <StyledModal
      aria-labelledby="modal-edition-in-progress-warning"
      open={ showChangeEditionWarning }
      onClose={ () => setShowChangeEditionWarning(false) }
      slotProps={ {
        backdrop: {
          sx: {
            background: alpha(theme.customColors.backgroundPrimary, 0.95),
            border: `${theme.spacing(0.4)} solid ${theme.customColors.borderPrimaryCta}`,
            boxShadow: `0 0 1rem 0rem ${alpha(theme.customColors.backgroundPrimaryCta, 0.95)},
0 0 2rem 0.25rem ${alpha(theme.customColors.backgroundPrimary, 0.95)}`
          }
        }
      } }
    >
      <Stack
        alignItems="center"
        gap={ 4 }
        sx={ { "&:focus-visible": { outline: "none" } } }
      >
        <Stack
          alignItems="center"
          gap={ 1 }
        >
          <Icon
            icon="Icons_obbligatorio"
            size={ 45 }
            color={ theme.customColors.textWarning }
          />
          <Typography
            color={ theme.customColors.textPrimary }
            fontSize="2.2rem"
            fontWeight={ 900 }
            sx={ { textAlign: "center" } }
          >
            { t("attention") }
          </Typography>
          <Typography
            color={ theme.customColors.exploreCardText }
            fontSize="1.15rem"
            sx={ { textAlign: "center", whiteSpace: "pre-line" } }
          >
            { t("edition_in_progress_warning") }
          </Typography>
        </Stack>
        <Stack
          direction="row"
          gap={ 2 }
        >
          <ButtonDigited
            typology={ "secondary" }
            text={ t("annul") }
            onClick={ () => setShowChangeEditionWarning(false) }
          />
          <ButtonDigited
            typology={ "primary" }
            text={ t("confirm") }
            onClick={ () => {
              setShowChangeEditionWarning(false);
              onChangeEditionClick?.();
            } }
            sx={ {
              ":hover": { backgroundColor: alpha(theme.customColors.backgroundPrimaryCta, 0.9) }
            } }
          />
        </Stack>
      </Stack>
    </StyledModal>
  );
}
